import { ReactElement } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import useHealthCheckRoutes from './getRoutes';

const Routes = (): ReactElement => {
  const routes = useHealthCheckRoutes();
  return (
    <Switch>
      {routes}
      <Redirect to="/sign-in" />
    </Switch>
  );
};

export default Routes;
